import { createFormHook, createFormHookContexts } from "@tanstack/react-form";
import { FileField } from "@/form/components/file.field";
import { InputField } from "@/form/components/input.field";
import { PhoneField } from "@/form/components/phone.field";
import { SelectField } from "@/form/components/select.field";
import { SubmitButton } from "@/form/components/submit.button";
import { TextareaField } from "@/form/components/textarea.field";
import { ToggleField } from "@/form/components/toggle.field";

export const { formContext, fieldContext, useFormContext, useFieldContext } =
  createFormHookContexts();

export const { useAppForm, withForm } = createFormHook({
  formContext,
  fieldContext,
  formComponents: {
    SubmitButton,
  },
  fieldComponents: {
    InputField,
    PhoneField,
    TextareaField,
    SelectField,
    FileField,
    ToggleField,
  },
});
